module.exports = __webpack_public_path__ + "static/img/novavida-logo.64d38628.png";